"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _WidgetSkeletonWrapper = require("./WidgetSkeletonWrapper");
Object.keys(_WidgetSkeletonWrapper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _WidgetSkeletonWrapper[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _WidgetSkeletonWrapper[key];
    }
  });
});
